import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);


class IntroMessagePage extends React.Component {

	constructor(props) {
		super(props);
    this.state = {};
	}

	render() {
		return <div className={'IntroMessagePage pageContent'}>
      <div className={'messageText firstBlock'}>During our inaugural year in Dallas we have been truly inspired by the culture and individuals that make this city so interesting and special. Because of this, we felt it was necessary to create a collection of some of our most exclusive, one-of-a-kind items that was representative of the individuality of this city I now call home. Our connection has only been magnified through our participation in some of the signature events that happen throughout the year. From cheering on the Cowboys every game day, to dancing the night away at The Crystal Charity Ball, we have chosen a collection of truly stunning pieces that show off what it means to be a Dallasite.</div>
      <div className='messageText'>I would like to personally invite you into our showroom to experience this beautiful collection first hand. We’re continually humbled by the opportunity to take part in your life’s most cherished moments and look forward to the celebrations to come.</div>
      <div className='salutationLabel'>Cheers,</div>
      <div className='signature'>
        <img src='/img/amit.png' />
      </div>
		</div>;
	}
}
export default IntroMessagePage;

function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

export const IntroMessagePageContainer = connect(
  mapStateToProps,
  allActionCreators
)(IntroMessagePage);


// WEBPACK FOOTER //
// ./src/components/views/page/IntroMessagePage.jsx